/** What the contact-client page reads from a shared job or to-do list link. */
export function contactClientData(link: any) {
  const data = link?.shared_link_data;
  return {
    uuid: link?.uuid,
    shared_link_data: {
      job: data?.job,
      homekeepers: data?.homekeepers,
      customer: data?.customer,
    },
  };
}
